import { CobranzasService } from './../../../../services/cobranzas/cobranzas.service';
import { Component, OnInit, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from "sweetalert2";
import { DatePipe,DecimalPipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesStatus,MessagesDates } from '../../../../models/messages';
import {HttpErrorResponse } from '@angular/common/http';

import * as moment from 'moment';
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-nuevo-reprogramacion',
  templateUrl: './nuevo-reprogramacion.component.html',
  styleUrls: ['./nuevo-reprogramacion.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesStatus,MessagesDates,
    DatePipe,
    DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class NuevoReprogramacionComponent implements OnInit {

  loading :boolean = false;
  save : boolean = false;  
  user:any;
  arrayFacturas :any=[];
  productosarr : any;
  flagCreateUpdate :boolean = false;
  titulo:string = "Nueva reprogramación";
  subtitulo: string = "";
  isLoading:boolean;

  NumeroFilter = new FormControl('');
  tipoMonedaFilter = new FormControl('');
  idComprobanteFilter = new FormControl('');
  filterValues = {
    Numero: '',
    Moneda: '',
    idComprobante: ''
    };  
  
  @Input() deuda : any;
  @Output() cerrarPopUp = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<boolean>();

  form : FormGroup;
  dataSource :any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [5,20,30,50,100,200];
  displayedColumns: string[] =['checked','idComprobante','Tipo_Comprobante','Tipo_Emision','Serie','Numero','Fecha_Vencimiento','Moneda','VNPP']
  monedaElement : string;

  constructor(private msgStatus:MessagesStatus,
              private msgTitulos : MessagesTitles,
              private datepipe :DatePipe,
              private decimalPipe: DecimalPipe,
              private cobranzasService : CobranzasService){
    
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.form = new FormGroup({
      "idComprobante": new FormControl({ value:'', disabled: true }),
      "Fecha_Registro": new FormControl(this.datepipe.transform(moment(),'yyyy-MM-dd')),
      "Monto_Negociado": new FormControl('',[Validators.required,Validators.pattern("^[0-9.,]+$")]),
      "Moneda": new FormControl(''),
      "VNPP": new FormControl({ value:'', disabled: true }),
      "Observacion": new FormControl(''),
      "Alta_Usuario": new FormControl(this.user.Usuario)
    })

  }

  ngOnInit(){
   this.ListadoDocumentosVencidos();

   this.NumeroFilter.valueChanges
   .subscribe(
     Numero => {
       this.filterValues.Numero = Numero;          
       this.dataSource.filter = JSON.stringify(this.filterValues);
     }
   )
 this.tipoMonedaFilter.valueChanges
   .subscribe(
     Moneda => {
       this.filterValues.Moneda = Moneda;
       this.dataSource.filter = JSON.stringify(this.filterValues);
     }
   )
 this.idComprobanteFilter.valueChanges
   .subscribe(
     idComprobante => {
       this.filterValues.idComprobante = idComprobante;          
       this.dataSource.filter = JSON.stringify(this.filterValues);
     }
   )
  }
  CerrarPopUp(){
    this.cerrarPopUp.emit();
    if (this.save) {
      this.refresh.emit();
      }
      this.refresh.emit();
  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Numero.toLowerCase().indexOf(searchTerms.Numero) !== -1
      && data.moneda_dsc.toString().toLowerCase().indexOf(searchTerms.Moneda) !== -1
      && data.idComprobante.toString().toLowerCase().indexOf(searchTerms.idComprobante) !== -1
    }
  }

  ListadoDocumentosVencidos(){
   this.isLoading = true

   this.cobranzasService.ObtenerDocumentosVencidos().subscribe(
     res =>{
         this.arrayFacturas = res;
         this.dataSource = new MatTableDataSource( this.arrayFacturas);
         this.dataSource.sort = this.sort;
         this.dataSource.paginator = this.paginator;
         this.dataSource.filterPredicate = this.createFilter(); 
         this.isLoading = false;
     },err =>{
         Swal.fire({
             title: "¡Algo salió mal!",
             text:  err.error['error'],
             type: "warning",
             allowOutsideClick: true,
             heightAuto: false 
         });
         this.isLoading = false;
     }
   )


  }

  onClick(element:any){
  this.form.controls['idComprobante'].setValue(element.idComprobante);
  this.form.controls['Monto_Negociado'].setValue(element.VNPP);
  this.form.controls['Moneda'].setValue(element.Moneda);
  this.form.controls['VNPP'].setValue(element.VNPP);
  this.form.controls['Observacion'].setValue(element.Observacion);
  }

  crearCobranzaReprogramada(){
    this.form.controls['Fecha_Registro'].setValue(this.datepipe.transform(this.form.controls['Fecha_Registro'].value,'yyyy-MM-dd'));
    this.form.controls["Monto_Negociado"].setValue(this.cortarComa(this.form.controls["Monto_Negociado"].value));

    if(this.form.invalid){
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "Complete los campos requeridos ",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      })
      return false;
    }
    if(this.form.controls['Monto_Negociado'].value <= 0){
      Swal.fire({
        title: "Advertencia",
        text: "Monto negociado no debe ser menor o igual que 0",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      })
      return false;
    }

    this.loading = true;
      this.cobranzasService.CrearCobranzaReprogramada(this.form.getRawValue()).subscribe(
        res => {
          this.loading = false;
          this.save = true;
        },(err: HttpErrorResponse)=> {
          this.loading = false;
          if (err.error instanceof ErrorEvent) {
              console.error("Error Event");
          } else {
              this.msgStatus.getMessage(err.status);            
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "Cobranza Reprogramada no registrado. "+this.msgStatus.message ,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        }
      )  
  }
  tranformarDecimal(control: any, decimal?: number) {
    let valor;
    if (decimal) {
      valor = this.decimalPipe.transform(
        this.cortarComa(this.form.controls[`${control}`].value),
        `1.${decimal}-${decimal}`
      );
    } else {
      valor = this.decimalPipe.transform(
        this.cortarComa(this.form.controls[`${control}`].value),
        `1.2-2`
      );
    }
    this.form.controls[`${control}`].setValue(valor);
  }
  
  cortarComa(numero: any): number {
    try {
      let cortado = numero.toString().replace(/,/gi, "");
      return Number(cortado);
    } catch (error) {
      return 0;
    }
  }


}
